import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { ModalContext } from 'App';
import TaxCreditModal from '../modals/TaxCreditModal';
import TaxCreditDetailsModal from '../modals/TaxCreditDetailsModal';
import DeductTaxCreditModal from '../modals/DeductTaxCreditModal';

function TaxCreditList({ data, businessId, business, handleAddTaxCredit }) {

  const setModal = useContext(ModalContext);
  const latestTaxCredit = data[data.length - 1];
  const showUpdateTaxCreditButton = data.length > 0 && get(latestTaxCredit, 'attributes.amount') > 0;
  const handleUpdateTaxCredit = info => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TaxCreditModal taxCreditData={info} type="EDIT" businessId={businessId} />,
      title: 'Update Tax Credit',
      modalSize: 'modal-md',
    });
  };
  const handleViewTaxCreditDetails = info => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TaxCreditDetailsModal taxCreditData={info} />,
      title: 'Tax Credit Details',
      modalSize: 'modal-md',
      hideHeader: false,
    });
  };
  const handleDeductTaxCredit = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <DeductTaxCreditModal id={businessId} maxAmount={+get(latestTaxCredit, 'attributes.balance', 0) || 0} />,
      title: 'Deduct Tax Credit',
      modalSize: 'modal-md',
      hideHeader: false,
    });
  };

  return (
    <>
      <div className='container-fluid card-section-content'>
        <div className='card-body'>
          <div className='row bg-white pb-3'>
            <div className='col-12'>
              <div className='form-wrapper p-3'>
                <div>
                  <table className="transaction-table table table-borderless table-sm">
                    <tbody>
                      <tr>
                        <td width="350" colSpan={6}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span
                              className="title"
                              style={{ fontSize: '16px' }}
                            >
                              TAX CREDIT
                            </span>
                            <div
                              className="d-flex"
                              style={{ gap: '.5rem' }}
                            >
                              {get(latestTaxCredit, 'attributes.balance') > 0 && (
                                <button
                                  type="button"
                                  className="btn btn-danger font-weight-bold"
                                  onClick={handleDeductTaxCredit}
                                >
                                  Deduct Tax Credit
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={handleAddTaxCredit(business)}
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                              >
                                Add Tax Credit &nbsp;&nbsp;
                                <i className="fas fa-plus" />
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="d-flex align-items-center">
                            <p className="label-secondary mb-0">
                              BALANCE: {get(business, 'attributes.tax_credit_human', '0.00') || '0.00'}
                            </p>
                            {showUpdateTaxCreditButton && (
                              <button
                                onClick={handleUpdateTaxCredit(latestTaxCredit)}
                                type="button"
                                className="btn-icon btn-sm"
                              >
                                <i className="far fa-edit text-info" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="transaction-table table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th className="text-center">
                          Date
                        </th>
                        <th className="text-center">
                          Amount
                        </th>
                        <th className="text-center">
                          Balance
                        </th>
                        <th className="text-center">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td className={`${get(item, 'attributes.amount') < 0 ? 'text-danger' : ''}`}>
                              {get(item, 'attributes.date_human') || '-'} 
                            </td>
                            <td className={`${get(item, 'attributes.amount') < 0 ? 'text-danger text-right' : 'text-right'}`}>
                              {get(item, 'attributes.amount_human') || '0.00'} 
                            </td>
                            <td className={`${get(item, 'attributes.amount') < 0 ? 'text-danger text-right' : 'text-right'}`}>
                              {get(item, 'attributes.balance_human') || '-'}
                            </td>
                            <td className="text-center">
                              <button
                                type='button'
                                className='btn btn-primary cms-bg-color-primary cms-outline-primary '
                                onClick={handleViewTaxCreditDetails(item)}
                              >
                                View Details
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

TaxCreditList.defaultProps = {
  data: {},
  businessId: '',
  business: {},
}

TaxCreditList.propTypes = {
  data: PropTypes.instanceOf(Array),
  businessId: PropTypes.string,
  business: PropTypes.instanceOf(Object),
  handleAddTaxCredit: PropTypes.instanceOf(Function).isRequired,
};

export default TaxCreditList;
